import clsx from 'clsx';
import { HTMLProps, forwardRef } from 'react';

import CheckIcon from '~/shared/assets/icons/check.svg';

const Checkbox = forwardRef<
  HTMLInputElement,
  HTMLProps<HTMLInputElement> & {
    className?: string;
  }
>(({ className, checked, disabled, ...inputProps }, ref) => {
  return (
    <div
      className={clsx(
        className,
        'rounded-[4px] w-[20px] h-[20px] border flex relative items-center justify-center z-0 transition-all duration-300',
        checked && !disabled
          ? 'bg-primary-500 hover:bg-primary-300 border-none'
          : !checked && disabled
            ? 'bg-[#F2F7FE] border-primary-50 border'
            : checked && disabled
              ? 'bg-azureish-white border-none'
              : 'bg-transparent border border-azureish-white hover:border-primary-400',
        disabled ? 'pointer-events-none' : 'cursor-pointer'
      )}
    >
      <CheckIcon
        className={clsx(
          ' stroke-white transition-opacity duration-200',
          checked ? 'opacity-100' : 'opacity-0'
        )}
      />

      <input
        ref={ref}
        type="checkbox"
        className={clsx('absolute z-10 opacity-0 w-full h-full ', disabled ? '' : 'cursor-pointer')}
        {...inputProps}
      />
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
